module.exports = __webpack_public_path__ + "static/img/edit.82ebf44f.svg";